export const SUPPORTED_FACETS = new Set<string>(['primary_colors', 'prices', 'business_department', 'category'])

export const FACET_TO_CONFIG: Record<
  string,
  {
    config: {
      columnsToShow: number
      label: string
      type: string
    }
    name: string
    priority: number
  }
> = {
  primary_colors: {
    config: {
      columnsToShow: 2,
      label: 'COLOR',
      type: 'Checkbox',
    },
    name: 'colors',
    priority: 1,
  },
  sizes: {
    name: 'sizes',
    config: {
      columnsToShow: 2,
      label: 'SIZE',
      type: 'Checkbox',
    },
    priority: 2,
  },
  prices: {
    name: 'prices',
    config: {
      columnsToShow: 1,
      label: 'PRICE RANGE',
      type: 'Checkbox',
    },
    priority: 3,
  },
  business_department: {
    name: 'departments',
    config: {
      columnsToShow: 2,
      label: 'DEPARTMENT',
      type: 'Checkbox',
    },
    priority: 4,
  },
  category: {
    name: 'categories',
    config: {
      columnsToShow: 2,
      label: 'CATEGORY',
      type: 'Checkbox',
    },
    priority: 5,
  },
}

export const PRICE_MAP: Record<string, { minPrice: number; maxPrice?: number }> = {
  '$0-10': {
    minPrice: 0,
    maxPrice: 10,
  },
  '$10-25': {
    minPrice: 10,
    maxPrice: 25,
  },
  '$25-50': {
    minPrice: 25,
    maxPrice: 50,
  },
  '$50-75': {
    minPrice: 50,
    maxPrice: 75,
  },
  '$75-100': {
    minPrice: 75,
    maxPrice: 100,
  },
  '$100-200': {
    minPrice: 100,
    maxPrice: 200,
  },
  '$200-300': {
    minPrice: 200,
    maxPrice: 300,
  },
  '$300-400': {
    minPrice: 300,
    maxPrice: 400,
  },
  '$400-500': {
    minPrice: 400,
    maxPrice: 500,
  },
  '$500-600': {
    minPrice: 500,
    maxPrice: 600,
  },
  '> $600': {
    minPrice: 600,
  },
}

export const PRICE_RANGES = [
  '$0-10',
  '$10-25',
  '$25-50',
  '$50-75',
  '$75-100',
  '$100-200',
  '$200-300',
  '$300-400',
  '$400-500',
  '$500-600',
  '> $600',
]

export const PRICE_RANGE_FILTER_CONFIG: Record<string, string[]> = {
  '$0-10': ['min_price>=0', 'max_price<=10'],
  '$10-25': ['min_price>=10', 'max_price<=25'],
  '$25-50': ['min_price>=25', 'max_price<=50'],
  '$50-75': ['min_price>=50', 'max_price<=75'],
  '$75-100': ['min_price>=75', 'max_price<=100'],
  '$100-200': ['min_price>=100', 'max_price<=200'],
  '$200-300': ['min_price>=200', 'max_price<=300'],
  '$300-400': ['min_price>=300', 'max_price<=400'],
  '$400-500': ['min_price>=400', 'max_price<=500'],
  '$500-600': ['min_price>=500', 'max_price<=600'],
  '> $600': ['min_price>=600'],
}

export const NUMERIC_FILTER_KEYS = ['prices']

export const FILTER_KEY_TO_FACET_KEY: Record<string, string> = {
  colors: 'primary_colors',
  departments: 'business_department',
  categories: 'category',
}
